import {
  Button,
  CircularProgress,
  Grid,
  Typography,
  Box,
  Chip,
} from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  People,
  CheckCircle,
  HourglassEmpty,
  PlayArrow,
  Groups,
} from "@mui/icons-material";

const GroupCard = ({ group, changeLevel, checkIfComplete }) => {
  const navigate = useNavigate();
  const { slugAssessment } = useParams();
  const [loading, setLoading] = useState(true);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    const check = async () => {
      const res = await checkIfComplete(group._id);
      setCompleted(res.valid);
      setLoading(false);
    };
    check();
  }, []);

  const handleResults = () => {
    changeLevel(0, group);
    navigate(`report`);
  };

  return (
    <Grid
      size={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        minHeight: "300px",
        border: "1px solid #0F5385",
        borderRadius: "8px",
      }}
    >
      <Box
        sx={{
          background: "linear-gradient(135deg, #0F5385 0%, #105B93 100%)",
          padding: "20px",
          color: "white",
          display: "flex",
          alignItems: "center",
          borderRadius: "8px 8px 0 0",
          justifyContent: "space-between",
        }}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <People sx={{ fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {group.name}
          </Typography>
        </Box>
        <Chip
          label={
            group?.completed
              ? "Completed"
              : completed
                ? "Processing"
                : "Not Started"
          }
          size="small"
          sx={{
            backgroundColor: group?.completed
              ? "#69AF45"
              : completed
                ? "#FFC107"
                : "#E3F2FD",
            color: group?.completed ? "white" : completed ? "white" : "#0F5385",
            fontWeight: 600,
          }}
        />
      </Box>

      <Box
        sx={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          flex: 1,
        }}
      >
        {/* Status Info */}
        <Box display="flex" alignItems="center" gap={1}>
          {group?.completed ? (
            <CheckCircle sx={{ color: "#69AF45", fontSize: 24 }} />
          ) : completed ? (
            <HourglassEmpty sx={{ color: "#FFC107", fontSize: 24 }} />
          ) : (
            <PlayArrow sx={{ color: "#0F5385", fontSize: 24 }} />
          )}
          <Box>
            <Typography
              variant="caption"
              sx={{ color: "#666", fontWeight: 500, display: "block" }}
            >
              Status
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#0F5385", fontWeight: 600 }}
            >
              {group?.completed
                ? "Completed"
                : completed
                  ? "Processing"
                  : "Not Started"}
            </Typography>
          </Box>
        </Box>

        {/* Member Count */}
        {group?.members && (
          <Box display="flex" alignItems="center" gap={1}>
            <Groups sx={{ color: "#0F5385", fontSize: 24 }} />
            <Box>
              <Typography
                variant="caption"
                sx={{ color: "#666", fontWeight: 500, display: "block" }}
              >
                Members
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#0F5385", fontWeight: 600 }}
              >
                {group.members.length}
              </Typography>
            </Box>
          </Box>
        )}

        <Box
          sx={{ height: "1px", backgroundColor: "#e0e0e0", margin: "8px 0" }}
        />

        {/* Action Buttons */}
        <Box sx={{ display: "flex", gap: "8px", marginTop: "12px" }}>
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            <>
              {group?.completed ? (
                <Button
                  onClick={handleResults}
                  variant="contained"
                  fullWidth
                  size="large"
                  sx={{
                    background:
                      "linear-gradient(135deg, #0F5385 0%, #105B93 100%)",
                    textTransform: "none",
                    fontWeight: 600,
                    color: "white",
                  }}
                >
                  View Results
                </Button>
              ) : (
                <>
                  {completed ? (
                    <Button
                      disabled
                      variant="contained"
                      fullWidth
                      size="large"
                      sx={{ textTransform: "none" }}
                    >
                      Processing
                    </Button>
                  ) : (
                    <Button
                      onClick={() => changeLevel(1, group)}
                      variant="contained"
                      fullWidth
                      size="large"
                      sx={{
                        background:
                          "linear-gradient(135deg, #0F5385 0%, #105B93 100%)",
                        textTransform: "none",
                        fontWeight: 600,
                        color: "white",
                      }}
                    >
                      Start Assessment
                    </Button>
                  )}
                </>
              )}
            </>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

export default GroupCard;
